import { useMemo } from "react";
import { useQuery } from "react-query";
import { GoodResponsesLibrary } from "@/v2/features/good-responses-library";
import { SimulatorWrapper as SimulatorWrapperV2 } from "@/v2/features/simulator/context/SimulatorWrapper";
import { SimulatorWrapper } from "@/routes/simulators/wrapper";
import { useSimulatorApi } from "@/v2/entities/simulator/Simulator.api";
import { Flex, Text, Spinner } from "@radix-ui/themes";

export default function GoodResponsesLibraryPage() {
  const simulatorApi = useSimulatorApi();

  const { data: simulators, isLoading } = useQuery({
    queryKey: ["simulators"],
    queryFn: () => simulatorApi.getSimulators(),
    enabled: true,
  });

  const firstSimulatorId = useMemo(() => {
    if (!simulators || simulators.length === 0) return undefined;
    return simulators[0].id.toString();
  }, [simulators]);

  if (isLoading) {
    return (
      <Flex justify="center" align="center" height="100%">
        <Spinner size="3" />
      </Flex>
    );
  }

  if (!firstSimulatorId) {
    return (
      <Flex
        justify="center"
        align="center"
        height="100%"
        direction="column"
        gap="3"
      >
        <Text size="4" weight="medium">
          No simulators found
        </Text>
        <Text size="2" color="gray">
          Please create a simulator first
        </Text>
      </Flex>
    );
  }

  return (
    <SimulatorWrapper simulatorId={firstSimulatorId}>
      <SimulatorWrapperV2 simulatorId={firstSimulatorId}>
        <GoodResponsesLibrary />
      </SimulatorWrapperV2>
    </SimulatorWrapper>
  );
}
